import { render, staticRenderFns } from "./awardManagement.vue?vue&type=template&id=30cffc3c&scoped=true&"
import script from "./awardManagement.vue?vue&type=script&lang=ts&"
export * from "./awardManagement.vue?vue&type=script&lang=ts&"
import style0 from "./awardManagement.vue?vue&type=style&index=0&id=30cffc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cffc3c",
  null
  
)

export default component.exports